var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.handleClick()}}},[_vm._v("Edit")])}
var staticRenderFns = []

export { render, staticRenderFns }